import Axios from 'axios'

const biRecollections = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BASE_URL_API + '/dashboard/bi/v1'
    return AxiosInstance
  },

  getPeriods(period) {
    return this.axios().get('/recoletas/periodos', {
      params: period ? { periodo: period } : {},
    })
  },

  getRecollections(period) {
    return this.axios().get('/recoletas', { params: { periodo: period } })
  },
}

export default biRecollections
